import type { LucideIcon } from "lucide-react";
import styles from "./attendance-empty-state.module.css";

type AttendanceEmptyStateProps = {
  icon: LucideIcon;
  title: string;
  description: string;
};

export function AttendanceEmptyState({
  icon: Icon,
  title,
  description,
}: AttendanceEmptyStateProps) {
  return (
    <div className={styles.emptyState}>
      <span className={styles.iconCircle} aria-hidden="true">
        <Icon size={30} strokeWidth={1.7} />
      </span>
      <h6 className={styles.title}>{title}</h6>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
